module.exports = __webpack_public_path__ + "static/media/logo.2e943f83.jpg";